import { render, staticRenderFns } from "./DeliverySettingsModal.vue?vue&type=template&id=491c6c83"
import script from "./DeliverySettingsModal.vue?vue&type=script&lang=js"
export * from "./DeliverySettingsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports